import gql from 'graphql-tag';

export const getAllDealsByAdmin = gql`
  query getAllDealsByAdmin($input: inputDealsAdmin) {
    getAllDealsByAdmin(input: $input) {
      count_rows
      current_page
      can_back
      can_next
      total_page
      deals {
        id
        offerPrice
        coinFromEarnedDealCoin
        createdAt
        offer {
          title
        }
        merchant {
          username
        }
        consumer {
          username
        }
      }
    }
  }
`;
